/**
 *
 *
 *
 */

export type EphemeralFirstLevelValues = Record<string, string[]>;

/*                                                                                  */
let pendingValues: EphemeralFirstLevelValues = {};

/*                                                                                                            */
export const ephemeralFirstLevelValues = $state<{ values: EphemeralFirstLevelValues }>({ values: {} });

/**
 *
 *
 */
export function savePendingEphemeralOrder(filterId: string, values: string[]) {
  if (!pendingValues[filterId]) {
    pendingValues[filterId] = values;
  }
}

/**
 *
 *
 */
export function commitEphemeralOrder() {
  if (Object.keys(pendingValues).length > 0) {
    ephemeralFirstLevelValues.values = { ...ephemeralFirstLevelValues.values, ...pendingValues };
    pendingValues = {};
  }
}

export function clearEphemeralFirstLevelValues() {
  ephemeralFirstLevelValues.values = {};
  pendingValues = {};
}
